import Vuex from 'vuex';
import Vue from 'vue';
import * as types from './mutation-types';

import auth from './modules/auth';
import restaurantTypes from './modules/restaurant-types';
import restaurants from './modules/restaurants';
import branches from './modules/branches';
import contactInfoTypes from './modules/contact-info-types';
import tags from './modules/tags';
import categories from './modules/categories';
import products from './modules/products';
import news from './modules/news';
import sliderImages from './modules/slider-images';
import users from './modules/users';
import orders from './modules/orders';
import roles from './modules/roles';
import admins from './modules/admins';
import notifications from './modules/notifications';
import stats from './modules/stats';
import comments from './modules/comments';
import notificationTemplates from './modules/notification-templates';
import customPages from './modules/custom-pages';
import reviews from './modules/reviews';
import tables from './modules/tables';
import reservations from './modules/reservations';
import companyValues from './modules/company-values';
import offers from './modules/offers';
import branchInfo from './modules/branch-info';
import coupons from './modules/coupons';

const debugging = process.env.NODE_ENV !== 'production';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		sidebarOpen: false,
		contentLocale: 'en',
	},

	modules: {
		auth,
		restaurantTypes,
		restaurants,
		branches,
		contactInfoTypes,
		tags,
		categories,
		products,
		news,
		sliderImages,
		users,
		orders,
		roles,
		admins,
		notifications,
		stats,
		comments,
		notificationTemplates,
		customPages,
		reviews,
		tables,
		reservations,
		offers,
		companyValues,
		branchInfo,
		coupons,
	},

	actions: {
		openSidebar({commit}) {
			commit(types.OPEN_SIDEBAR);
		},

		closeSidebar({commit}) {
			commit(types.CLOSE_SIDEBAR);
		},

		setContentLocale({commit}, locale) {
			axios.defaults.headers.common['Accept-Language'] = locale;
			commit(types.SET_CONTENT_LOCALE, locale);
		}
	},

	mutations: {
		[types.OPEN_SIDEBAR](state) {
			state.sidebarOpen = true;
		},

		[types.CLOSE_SIDEBAR](state) {
			state.sidebarOpen = false;
		},

		[types.SET_CONTENT_LOCALE](state, locale) {
			state.contentLocale = locale;
		},
	},

	strict: debugging
});